<template>
  <el-upload
    action=""
    class="chat-upload"
    :show-file-list="false"
    :http-request="sendImg"
    :before-upload="beforeUpload"
  >
    <i class="chat iconfont iconimage"></i>
  </el-upload>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      image: null
    }
  },

  computed: {
    ...mapState(['receivingUser'])
  },

  methods: {
    ...mapActions(['sendImgMessage']),

    beforeUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      var isLt2M = file.size / 1024 < 2048

      if (!isJPG) {
        this.$message.error(this.$t('Uploaded image only support png and jpg'))
        return false
      }
      if (!isLt2M) {
        this.$message.error(this.$t('Uploaded image can not greater than 1Mb'))
      }
      return isJPG && isLt2M
    },

    sendImg(req) {
      let fileObj = {
        data: req.file,
        filename: req.file.name,
        filetype: req.file.type,
        url: window.URL.createObjectURL(req.file)
      }
      let obj = {
        chatType: 'singleChat',
        chatId: this.receivingUser,
        file: fileObj,
        roomType: false
      }
      this.sendImgMessage(obj)
    }
  }
}
</script>
<style>
.chat-upload .chat.iconfont {
  margin-right: 10px;
  font-size: 25px;
}
</style>
